import React, { useEffect, useState } from "react";
import tw from "twin.macro";

/* framer-motion and useInView here are used to animate the sections in when we reach them in the viewport
 */
import { motion } from "framer-motion";
import useInView from "@owaiswiz/use-in-view";

// No overflow on this wrapper — overflow-x-hidden here created a nested vertical scrollbar.
const StyledDiv = tw.div`font-display min-h-screen text-secondary-500 px-2 py-2`;

function AnimationReveal({ disabled, children }) {
  if (disabled) {
    return <>{children}</>;
  }

  if (!Array.isArray(children)) children = [children];

  const childrenWithAnimation = children.map((child, i) => {
    return <AnimatedSlideInComponent key={i}>{child}</AnimatedSlideInComponent>;
  });
  return <>{childrenWithAnimation}</>;
}

function AnimatedSlideInComponent({ children }) {
  const [ref, inView] = useInView(30);

  return (
    <motion.section
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 28 }}
      transition={{ type: "spring", damping: 22, stiffness: 160 }}
      style={{ willChange: "opacity, transform" }}
    >
      {children}
    </motion.section>
  );
}

function scrollToHash() {
  const hash = window.location.hash?.slice(1);
  if (!hash) return;
  const el = document.getElementById(hash);
  if (el) {
    const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top, behavior: "smooth" });
  }
}

export default (props) => {
  // Hash deep-links jump before IntersectionObserver runs. Skip reveal when a hash is present.
  const [disableForHash, setDisableForHash] = useState(
    () => typeof window !== "undefined" && window.location.hash.length > 1
  );

  useEffect(() => {
    const onHashChange = () => {
      if (window.location.hash.length > 1) {
        setDisableForHash(true);
        requestAnimationFrame(() => scrollToHash());
      }
    };

    if (window.location.hash.length > 1) {
      setDisableForHash(true);
      requestAnimationFrame(() => scrollToHash());
    }

    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return (
    <StyledDiv className="App">
      <AnimationReveal {...props} disabled={props.disabled || disableForHash} />
    </StyledDiv>
  );
};
